export default __webpack_public_path__ + "static/media/blob.right-lg.114149a9.png";